exports.components = {
  "component---src-components-type-template-tsx": () => import("./../../../src/components/typeTemplate.tsx" /* webpackChunkName: "component---src-components-type-template-tsx" */),
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-index-mdx": () => import("./../../../src/pages/index.mdx" /* webpackChunkName: "component---src-pages-index-mdx" */),
  "component---src-pages-serialization-mdx": () => import("./../../../src/pages/serialization.mdx" /* webpackChunkName: "component---src-pages-serialization-mdx" */)
}

